<template>
  <div class="hero-2">
    <div class="main-container">
      <div class="info-container">
        <div class="info-wrapper">
          <div class="heading-1" v-html="field.value.text"></div>
          <div class="description heading-3-regular" v-html="field.value.text2 "></div>
        </div>
      </div>
      <div class="asset-container">
        <div class="asset-wrapper">
          <img v-scroll-animate :src="field.value.image" alt="">
        </div>
      </div>
      <div class="description description-mobile heading-3-regular" v-html=" field.value.text2"></div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'Hero-2',
  props: {
    field: {
      type: Object
    }
  },

}
</script>

<style lang="scss">
@import "Hero2";
</style>
